// Side-view staircase loader. Pass `progress` (0-100) to reflect real progress;
// omit it for the looping "indeterminate" animation. `dark` forces black label/percent text.
export default function StaircaseLoader({ label, width = 248, progress = null, dark = false, white = false, red = false }) {
  const height = Math.round((width * 210) / 262);
  // 5-step ascending staircase path (bottom-left -> top-right)
  const d = "M 14 190 h 44 v -32 h 44 v -32 h 44 v -32 h 44 v -32 h 44 v -32";
  const hasProgress = typeof progress === "number";
  const pct = Math.max(0, Math.min(100, progress ?? 0));
  const fillStyle = {
    ...(hasProgress ? { strokeDasharray: 100, strokeDashoffset: 100 - pct, animation: "none", transition: "stroke-dashoffset .5s ease" } : {}),
    ...(red ? { stroke: "#dc2626", filter: "drop-shadow(0 3px 8px rgba(220,38,38,.40))" } : {}),
  };
  const hasFillStyle = hasProgress || red;
  return (
    <div className="flex flex-col items-center" data-testid="staircase-loader" role="status" aria-live="polite" aria-label="Progress">
      <span className="sr-only">{hasProgress ? `${Math.round(pct)} percent` : "Working…"}</span>
      <svg width={width} height={height} viewBox="0 0 262 210" fill="none">
        {/* 1pt black outline behind the bar */}
        <path d={d} stroke="#171426" strokeWidth="14" strokeLinecap="round" strokeLinejoin="round" />
        <path d={d} className="stair-track" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" />
        <path d={d} className="stair-fill" style={hasFillStyle ? fillStyle : undefined} strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" pathLength="100" />
      </svg>
      {hasProgress && (
        <p data-testid="staircase-percent" className={`font-extrabold mt-1 text-xl tabular-nums ${white ? "text-white" : dark ? "text-[#171426]" : "text-[#1e3aaa]"}`}>{Math.round(pct)}%</p>
      )}
      {label && <p className={`font-semibold mt-1 ${white ? "text-white" : dark ? "text-[#171426]" : "text-[#9a96ac]"}`}>{label}</p>}
    </div>
  );
}
